__turbopack_context__.v({
  "card-edit-input-container": "LinkStatusContainer-module-scss-module__ONTOIG__card-edit-input-container",
  "link-chip-container": "LinkStatusContainer-module-scss-module__ONTOIG__link-chip-container",
});
